import {STATES} from '../data/uiData'

angular.module('clientDashboardApp').factory('stateService', function ($rootScope, $q) {

  let state = STATES.init

  return {
    getState: () => {
      return state
    },
    setState: (newState) => {
      state = newState;
    }
  }


})
